import { emitClosedEvent } from "./eventEmitter";

const buildCinema = (cinemaTracking, featureIndex) => {
    const { labels } = cinemaTracking;
    return {
        ...cinemaTracking,
        position: parseInt(featureIndex, 10),
        status: "collapsed",
        labels,
    };
};

export default (cinemaTracking, featureIndex, variationId) => {
    const event = {
        name: "close",
        features: [buildCinema(cinemaTracking, featureIndex)],
    };

    const closedAdditionalLabels = {
        product_VariationId: [variationId],
    };
    emitClosedEvent(event, closedAdditionalLabels);
};
